import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Comment from './Comment';

const CommentsList = props => {
    const filteredComments = props.commentsStore.filteredComments;

    const renderComment = comment =>
        (<Comment
            key={comment.id.toString()}
            comment={comment}
            expanded={props.commentsStore.expanded}
            commentsStore={props.commentsStore}
        />);

    return (<div className='comments-list'>
        { filteredComments && filteredComments.map(renderComment) }
    </div>);
};

export default observer(CommentsList);

CommentsList.propTypes = {
    commentsStore: PropTypes.object.isRequired
};
